let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("02EjQ")]).then(() => parcelRequire('j3YP6'));